import BaseModel from "./base/baseModel";

export default class ProdutoFormaFarmaceuticaModel extends BaseModel {
    id?: number = null;
    produtoId?: number = null;
    formaFarmaceuticaId?: number = null;
    produtoDescricao?: string = null;
    formaFarmaceuticaDescricao?: string = null;
}
